var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n\t\t\t其他险种出险-" + _vm._s(_vm.ruleForm.id === null || _vm.ruleForm.id === '' ? '新增' : '修改'))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "540px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "padding": "100px",
      "overflow-x": "hidden"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("| ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #DADADA",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "label": "保单名称",
      "prop": "insurance_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "74%"
    },
    attrs: {
      "placeholder": "请选择保单名称",
      "clearable": ""
    },
    on: {
      "change": _vm.sbm
    },
    model: {
      value: (_vm.ruleForm.insurance_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "insurance_id", $$v)
      },
      expression: "ruleForm.insurance_id"
    }
  }, _vm._l((_vm.bdList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.insurance_name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "50px",
      "width": "80%"
    },
    attrs: {
      "label": "保单号",
      "prop": "policy"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.policy_no),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "policy_no", $$v)
      },
      expression: "ruleForm.policy_no"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "唯一识别码",
      "prop": "detailed_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "74%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.project_placeholder,
      "clearable": ""
    },
    on: {
      "change": _vm.ChangeDetailed
    },
    model: {
      value: (_vm.ruleForm.detailed_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "detailed_id", $$v)
      },
      expression: "ruleForm.detailed_id"
    }
  }, _vm._l((_vm.sbmtList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.unique_id,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "名称/品牌",
      "prop": "brand"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.brand),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "brand", $$v)
      },
      expression: "ruleForm.brand"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "型号/规格",
      "prop": "model"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.model),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "model", $$v)
      },
      expression: "ruleForm.model"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("| ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("出险信息")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #DADADA",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "label": "出险时间",
      "prop": "danger_time"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "73%"
    },
    attrs: {
      "type": "datetime",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "placeholder": "请选择出险时间"
    },
    model: {
      value: (_vm.ruleForm.danger_time),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "danger_time", $$v)
      },
      expression: "ruleForm.danger_time"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "label": "出险经过",
      "prop": "danger_after"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2
    },
    model: {
      value: (_vm.ruleForm.danger_after),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "danger_after", $$v)
      },
      expression: "ruleForm.danger_after"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "事故照片",
      "prop": "accident_photo"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "list-type": "picture-card",
      "on-preview": _vm.sghandlePictureCardPreview,
      "limit": 4,
      "on-remove": _vm.handleRemove,
      "file-list": _vm.ruleForm.accident_photo,
      "on-success": _vm.sghandleAvatarSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.ruleForm.accident_photo,
      "alt": ""
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "报案号",
      "prop": "report_no"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入报案号"
    },
    model: {
      value: (_vm.ruleForm.report_no),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "report_no", $$v)
      },
      expression: "ruleForm.report_no"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "保单号",
      "prop": "policy_no"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入保单号"
    },
    model: {
      value: (_vm.ruleForm.policy_no),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "policy_no", $$v)
      },
      expression: "ruleForm.policy_no"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "理赔情况",
      "prop": "settlement_status"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "73%"
    },
    attrs: {
      "placeholder": "请选择理赔情况",
      "clearable": ""
    },
    on: {
      "change": _vm.saveRules
    },
    model: {
      value: (_vm.ruleForm.settlement_status),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "settlement_status", $$v)
      },
      expression: "ruleForm.settlement_status"
    }
  }, _vm._l((_vm.ztList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "医疗票据",
      "prop": "bill_url"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "limit": 1,
      "on-remove": _vm.handleRemove,
      "file-list": _vm.ruleForm.bill_url,
      "on-success": _vm.handleAvatarSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.ruleForm.bill_url,
      "alt": ""
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "收保险公司理赔款",
      "prop": "settlement_amount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入收保险公司理赔款"
    },
    model: {
      value: (_vm.ruleForm.settlement_amount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "settlement_amount", $$v)
      },
      expression: "ruleForm.settlement_amount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "付员工理赔款",
      "prop": "indemnity_amount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入付员工理赔款"
    },
    model: {
      value: (_vm.ruleForm.indemnity_amount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "indemnity_amount", $$v)
      },
      expression: "ruleForm.indemnity_amount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "结案日期",
      "prop": "close_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "73%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "请选择结案日期"
    },
    model: {
      value: (_vm.ruleForm.close_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "close_date", $$v)
      },
      expression: "ruleForm.close_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "情况备注",
      "prop": "remarks"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写备注"
    },
    model: {
      value: (_vm.ruleForm.remarks),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "remarks", $$v)
      },
      expression: "ruleForm.remarks"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "400px",
      "margin-top": "50px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id === null || _vm.ruleForm.id === ''),
      expression: "ruleForm.id === null || ruleForm.id === ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.Update('ruleForm')
      }
    }
  }, [_vm._v("修改")])], 1)], 1)], 1)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f684c2a","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bxgl/QtxzCx/Qtxzcx_add.vue
// module id = null
// module chunks = 